export default __webpack_public_path__ + "static/media/exterior8.5ce927c7.jpg";